<app-page-heading [key]="'forced-checkin.page-title'"
                  [subheadingIcon]="'fa fa-truck'"
                  [disableMarginBottom]="true">
</app-page-heading>

<div class="main-content">
    <app-forced-checkin-bucket [class.hidden]="!showBucket"
                               [regionId]="regionIdFromQueryParams"
                               [selectedPlantGlid]="selectedPlantGlid"
                               (selectedPlantGlidChange)="selectPlant($event)"
                               (reloadPlantResults)="reloadPlantResults(selectedPlantGlid)"
                               (selectedRegionChange)="regionSelected($event)"
                               (selectedCarrierChange)="carrierSelected($event)"
                               [(dateRange)]="dateRange"
                               [(forcedCheckinResult)]="forcedCheckinResult"
                               [(showBucket)]="showBucket">
    </app-forced-checkin-bucket>

    <app-forced-checkin-map [selectedPlantGlid]="selectedPlantGlid"
                            [selectedPlantRadius]="selectedPlantRadius"
                            (selectedPlantGlidChange)="selectPlant($event)"
                            [forcedCheckinResults]="forcedCheckinResult"
                            [plantForcedCheckins]="plantForcedCheckinResult"
                            [(showBucket)]="showBucket">
    </app-forced-checkin-map>
</div>
